import moment from 'moment-timezone';

const STORAGE_KEY = 'mock_supplement_tutor_tasks';

export const SUPPLEMENT_STUDY_LEVELS = [
  { id: 'basic', name: 'Basic' },
  { id: 'pre_ielts', name: 'Pre-IELTS' },
  { id: 'ielts_35_45', name: 'IELTS 3.5 - 4.5' },
  { id: 'ielts_45_55', name: 'IELTS 4.5 - 5.5' },
  { id: 'ielts_55_65', name: 'IELTS 5.5 - 6.5' },
  { id: 'ielts_65_70_plus', name: 'IELTS 6.5 - 7.0+' }
];

export const SUPPLEMENT_CAPABILITIES_BY_LEVEL = {
  basic: [
    { id: 'basic_grammar', name: 'Cung co ngu phap co ban' },
    { id: 'basic_pronunciation', name: 'Sua phat am nen tang' },
    { id: 'basic_vocab', name: 'Mo rong tu vung chu de co ban' }
  ],
  pre_ielts: [
    { id: 'pre_listening', name: 'Pre-IELTS Listening foundation' },
    { id: 'pre_reading', name: 'Pre-IELTS Reading foundation' },
    { id: 'pre_writing', name: 'Pre-IELTS Writing sentence building' }
  ],
  ielts_35_45: [
    { id: '35_speaking', name: 'IELTS Speaking band 3.5 - 4.5' },
    { id: '35_listening', name: 'IELTS Listening band 3.5 - 4.5' },
    { id: '35_reading', name: 'IELTS Reading band 3.5 - 4.5' }
  ],
  ielts_45_55: [
    { id: '45_speaking', name: 'IELTS Speaking band 4.5 - 5.5' },
    { id: '45_writing', name: 'IELTS Writing band 4.5 - 5.5' },
    { id: '45_reading', name: 'IELTS Reading band 4.5 - 5.5' }
  ],
  ielts_55_65: [
    { id: '55_speaking', name: 'IELTS Speaking band 5.5 - 6.5' },
    { id: '55_writing', name: 'IELTS Writing band 5.5 - 6.5' },
    { id: '55_reading', name: 'IELTS Reading band 5.5 - 6.5' }
  ],
  ielts_65_70_plus: [
    { id: '65_advanced_speaking', name: 'IELTS Speaking 6.5 - 7.0+' },
    { id: '65_advanced_writing', name: 'IELTS Writing 6.5 - 7.0+' },
    { id: '65_advanced_coaching', name: 'Chien luoc luyen de 6.5 - 7.0+' }
  ]
};

const BASE_SLOTS = [
  { code: 'morning', start: '08:00', end: '09:30' },
  { code: 'morning', start: '09:45', end: '11:15' },
  { code: 'afternoon', start: '13:30', end: '15:00' },
  { code: 'afternoon', start: '15:15', end: '16:45' },
  { code: 'evening', start: '18:00', end: '19:30' },
  { code: 'evening', start: '19:45', end: '21:15' }
];

function getStorage() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }

  return window.localStorage;
}

function readStoredTasks() {
  const storage = getStorage();

  if (!storage) {
    return [];
  }

  try {
    const raw = storage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    return [];
  }
}

function writeStoredTasks(tasks) {
  const storage = getStorage();

  if (!storage) {
    return;
  }

  storage.setItem(STORAGE_KEY, JSON.stringify(tasks));
}

function getLevelName(levelId) {
  return SUPPLEMENT_STUDY_LEVELS.find((item) => item.id === levelId)?.name || '-';
}

function getCapabilityName(levelId, capabilityId) {
  return getSupplementCapabilities(levelId).find((item) => item.id === capabilityId)?.name || '-';
}

function buildIsoDateTime(date, time) {
  return moment.tz(`${date} ${time}`, 'YYYY-MM-DD HH:mm', 'Asia/Ho_Chi_Minh').toISOString();
}

function formatWorkTime(date, time) {
  const start = moment.tz(`${date} ${time}`, 'YYYY-MM-DD HH:mm', 'Asia/Ho_Chi_Minh');
  return `${start.format('DD/MM/YYYY HH:mm')} - ${start.clone().add(90, 'minutes').format('HH:mm')}`;
}

function normalizeMockTask(task) {
  const createdAt = task.created_at || moment().format('DD/MM/YYYY HH:mm:ss');
  const workTime = task.work_time || formatWorkTime(task.study_date, task.study_time);

  return {
    id: task.id,
    code: task.id,
    type: 4,
    type_label: 'Gia sư',
    taskTypeName: 'Gia sư',
    subtype: 7,
    subtype_label: 'Gia sư bổ trợ',
    categoryName: 'Gia sư bổ trợ',
    handler: task.class_code,
    target: task.class_code,
    status: task.status ?? 0,
    work_time: workTime,
    workTime,
    assignee: task.assignee || '-',
    assigneeName: task.assignee || '-',
    created_at: createdAt,
    createdAt,
    rating: task.rating ?? '',
    attendance_status: task.attendance_status || 'not_attended',
    supplement_students: getMockStudents(task),
    supplement_reviews: task.supplement_reviews || [],
    detail: {
      class_code: task.class_code,
      study_level_name: task.study_level_name,
      capability_name: task.capability_name,
      zalo_link: task.zalo_link,
      total_students: task.total_students,
      study_date: task.study_date,
      study_time: task.study_time,
      support_type: 'supplement',
      students: getMockStudents(task)
    }
  };
}

function getMockStudents(task) {
  if (Array.isArray(task.students) && task.students.length) {
    return task.students;
  }

  const totalStudents = Number(task.total_students) || 0;

  return Array.from({ length: totalStudents }, (_, index) => ({
    id: `mock-student-${index + 1}`,
    code: `2024${String(index + 1).padStart(3, '0')}`,
    name: [
      'Nguyen Hoang Nam',
      'Tran Thi Mai Anh',
      'Le Minh Tuan',
      'Pham Thanh Thao',
      'Do Quang Vinh',
      'Vu Ha Linh',
      'Bui Tung Duong'
    ][index] || `Hoc vien ${index + 1}`,
    attendance_status: 'present',
    review_result: '',
    review_note: ''
  }));
}

function mapReviewSummary(reviews) {
  return {
    passed: reviews.filter((item) => item.result === 'passed').length,
    failed: reviews.filter((item) => item.result === 'failed').length,
    no_homework: reviews.filter((item) => item.result === 'no_homework').length
  };
}

export function getSupplementCapabilities(levelId) {
  return SUPPLEMENT_CAPABILITIES_BY_LEVEL[levelId] || [];
}

export function getSupplementSlotsByDate(date) {
  if (!date) {
    return [];
  }

  const selectedDate = moment(date, 'YYYY-MM-DD');
  const dayOfMonth = Number(selectedDate.format('D'));

  return BASE_SLOTS.map((slot, index) => {
    const isoStart = buildIsoDateTime(date, slot.start);
    const shouldDisable = dayOfMonth % 5 === 0 || ((dayOfMonth + index) % 4 === 0);

    return {
      ...slot,
      label: `${slot.start} - ${slot.end}`,
      start: slot.start,
      end: slot.end,
      isoStart,
      disable: shouldDisable
    };
  });
}

export function hasSupplementAvailableSlots(date) {
  return getSupplementSlotsByDate(date).some((slot) => !slot.disable);
}

export function createSupplementTutorTask(payload) {
  const createdAt = moment().format('DD/MM/YYYY HH:mm:ss');
  const nextTask = {
    id: `SUP-${moment().format('YYMMDDHHmmss')}`,
    class_code: payload.class_code,
    study_level: payload.study_level,
    study_level_name: getLevelName(payload.study_level),
    capability_id: payload.capability_id,
    capability_name: getCapabilityName(payload.study_level, payload.capability_id),
    zalo_link: payload.zalo_link,
    total_students: payload.total_students,
    study_date: payload.study_date,
    study_time: payload.study_time,
    status: 0,
    rating: '',
    created_at: createdAt,
    work_time: formatWorkTime(payload.study_date, payload.study_time)
  };

  const tasks = readStoredTasks();
  tasks.unshift(nextTask);
  writeStoredTasks(tasks);

  return normalizeMockTask(nextTask);
}

export function getSupplementTutorMockTasks() {
  return readStoredTasks().map(normalizeMockTask);
}

export function getSupplementTutorMockTaskById(id) {
  const task = readStoredTasks().find((item) => item.id === id);

  if (!task) {
    return null;
  }

  const normalizedTask = normalizeMockTask(task);
  const startAt = moment.tz(`${task.study_date} ${task.study_time}`, 'YYYY-MM-DD HH:mm', 'Asia/Ho_Chi_Minh');

  return {
    id: normalizedTask.id,
    type: 7,
    subtype: 7,
    status: normalizedTask.status,
    attendance_status: task.attendance_status || 'not_attended',
    supplement_students: getMockStudents(task),
    supplement_reviews: task.supplement_reviews || [],
    supplement_result: mapReviewSummary(task.supplement_reviews || []),
    user_name: task.class_code,
    user_phone: '-',
    user_id: null,
    best_customer_id: null,
    subtype_label: 'Gia sư bổ trợ',
    level_out_name: task.study_level_name,
    created_at: normalizedTask.createdAt,
    work_time: normalizedTask.workTime,
    start_date: startAt.toISOString(),
    detail: {
      id: normalizedTask.id,
      type: 7,
      lesson: `Nhom ${task.total_students} hoc vien`,
      content: [task.capability_name],
      date: task.study_date,
      start_time: task.study_time,
      end_time: startAt.clone().add(90, 'minutes').format('HH:mm'),
      level: task.study_level_name,
      center_name: '-',
      class_code: task.class_code,
      capability_name: task.capability_name,
      study_level_name: task.study_level_name,
      total_students: task.total_students,
      zalo_link: task.zalo_link
    },
    work_results: {
      admin_join_name: '-',
      admin_joined_at: null,
      tool: '-',
      admin_checkin: '-',
      admin_checkin_at: null,
      link_checkin: '',
      attendance_status: task.attendance_status || 'not_attended',
      supplement_result: mapReviewSummary(task.supplement_reviews || []),
      supplement_reviews: task.supplement_reviews || [],
      rating: '',
      feedbacks: [],
      feedback_note: ''
    },
    action_buttons: []
  };
}

export function updateSupplementTutorAttendance(id, attendances = []) {
  const tasks = readStoredTasks();
  const taskIndex = tasks.findIndex((item) => item.id === id);

  if (taskIndex === -1) {
    return null;
  }

  const task = tasks[taskIndex];
  const currentStudents = getMockStudents(task);
  const nextStudents = currentStudents.map((student) => {
    const attendance = attendances.find((item) => String(item.id || item.student_id) === String(student.id));

    return {
      ...student,
      attendance_status: attendance?.status || attendance?.attendance_status || student.attendance_status || 'present'
    };
  });

  tasks[taskIndex] = {
    ...task,
    students: nextStudents,
    attendance_status: 'attended',
    status: 5
  };
  writeStoredTasks(tasks);

  return getSupplementTutorMockTaskById(id);
}

export function updateSupplementTutorReviews(id, reviews = []) {
  const tasks = readStoredTasks();
  const taskIndex = tasks.findIndex((item) => item.id === id);

  if (taskIndex === -1) {
    return null;
  }

  const task = tasks[taskIndex];
  const currentStudents = getMockStudents(task);
  const nextStudents = currentStudents.map((student) => {
    const review = reviews.find((item) => String(item.id || item.student_id) === String(student.id));

    if (!review) {
      return student;
    }

    return {
      ...student,
      review_result: review.result,
      review_note: review.note || ''
    };
  });

  tasks[taskIndex] = {
    ...task,
    students: nextStudents,
    supplement_reviews: reviews,
    status: 1
  };
  writeStoredTasks(tasks);

  return getSupplementTutorMockTaskById(id);
}
